import {Country, RegionType} from "@pg-rp/common-types";

import {aggregationToCityMap} from "../constants/aggregation_to_city_map";
import {IInteractiveRegion} from "../types/IInteractiveRegion";
import {getRegionParentId, ISelectedRegionParam} from "./get_region_parent_id";

export type IRegionListRegionParam = Pick<IInteractiveRegion, "id" | "type">;

export const validateSelectedRegionsWithAvailableDistrictsAndSurroundings = (
    selectedRegions?: ISelectedRegionParam[],
    availableDistrictsAndSurroundings?: IRegionListRegionParam[]
) => {
    if (!selectedRegions || selectedRegions.length === 0 || !availableDistrictsAndSurroundings || availableDistrictsAndSurroundings.length === 0) {
        // empty region request or response
        return false;
    }

    if (selectedRegions.some(({country}) => country && country !== Country.POLAND)) {
        // disable foreign regions
        return false;
    }

    if (
        selectedRegions.length === 1 &&
        selectedRegions[0].type === RegionType.CITY &&
        availableDistrictsAndSurroundings.some((region) => region.type === RegionType.DISTRICT)
    ) {
        // only one city selected with available districts
        return true;
    }

    if (selectedRegions.length === 1 && aggregationToCityMap.has(selectedRegions[0].id)) {
        // selected only aggregation region
        return true;
    }

    if (selectedRegions.every((region) => region.type === RegionType.DISTRICT && getRegionParentId(region) === getRegionParentId(selectedRegions[0]))) {
        // districts from the same city
        return true;
    }

    if (
        selectedRegions.every((region) => region.type === RegionType.DISTRICT || region.type === RegionType.COUNTY || region.type === RegionType.SURROUNDINGS)
    ) {
        // districts, counties or surroundings, all should be available as city surroundings or city districts
        return selectedRegions.every((selectedRegion) => {
            return availableDistrictsAndSurroundings.some((availableRegion) => availableRegion.id === selectedRegion.id);
        });
    }

    // only one city has been selected with surroundings
    const mainCity = selectedRegions.find((region) => region.type === RegionType.CITY);
    if (mainCity && selectedRegions.every((region) => getRegionParentId(region) === mainCity.id || region.id === mainCity.id)) {
        return selectedRegions.every((selectedRegion) => {
            return (
                selectedRegion.type !== RegionType.SURROUNDINGS ||
                availableDistrictsAndSurroundings.some((availableRegion) => availableRegion.id === selectedRegion.id)
            );
        });
    }

    return false;
};
import {Country, RegionType} from "@pg-rp/common-types";

import {aggregationToCityMap} from "../constants/aggregation_to_city_map";
import {IInteractiveRegion} from "../types/IInteractiveRegion";
import {getRegionParentId, ISelectedRegionParam} from "./get_region_parent_id";

export type IRegionListRegionParam = Pick<IInteractiveRegion, "id" | "type">;

export const validateSelectedRegionsWithAvailableDistrictsAndSurroundings = (
    selectedRegions?: ISelectedRegionParam[],
    availableDistrictsAndSurroundings?: IRegionListRegionParam[]
) => {
    if (!selectedRegions || selectedRegions.length === 0 || !availableDistrictsAndSurroundings || availableDistrictsAndSurroundings.length === 0) {
        // empty region request or response
        return false;
    }

    if (selectedRegions.some(({country}) => country && country !== Country.POLAND)) {
        // disable foreign regions
        return false;
    }

    if (
        selectedRegions.length === 1 &&
        selectedRegions[0].type === RegionType.CITY &&
        availableDistrictsAndSurroundings.some((region) => region.type === RegionType.DISTRICT)
    ) {
        // only one city selected with available districts
        return true;
    }

    if (selectedRegions.length === 1 && aggregationToCityMap.has(selectedRegions[0].id)) {
        // selected only aggregation region
        return true;
    }

    if (selectedRegions.every((region) => region.type === RegionType.DISTRICT && getRegionParentId(region) === getRegionParentId(selectedRegions[0]))) {
        // districts from the same city
        return true;
    }

    if (
        selectedRegions.every((region) => region.type === RegionType.DISTRICT || region.type === RegionType.COUNTY || region.type === RegionType.SURROUNDINGS)
    ) {
        // districts, counties or surroundings, all should be available as city surroundings or city districts
        return selectedRegions.every((selectedRegion) => {
            return availableDistrictsAndSurroundings.some((availableRegion) => availableRegion.id === selectedRegion.id);
        });
    }

    // only one city has been selected with surroundings
    const mainCity = selectedRegions.find((region) => region.type === RegionType.CITY);
    if (mainCity && selectedRegions.every((region) => getRegionParentId(region) === mainCity.id || region.id === mainCity.id)) {
        return selectedRegions.every((selectedRegion) => {
            return (
                selectedRegion.type !== RegionType.SURROUNDINGS ||
                availableDistrictsAndSurroundings.some((availableRegion) => availableRegion.id === selectedRegion.id)
            );
        });
    }

    return false;
};
